import React from 'react';
import { getFundClass } from '@finect/front-resources/Products';
import { DateLabel } from '../../../../DateLabel';
import { LastQuote } from './LastQuote';
export var LastQuoteHeadline = function LastQuoteHeadline(_ref) {
  var product = _ref.product;
  var lastQuote = product.entity.lastQuote;
  var lastPrice = product.entity.lastQuote.price;
  var fundClass = getFundClass(product.entity);
  var currency = fundClass ? fundClass.currency : null;
  var labelComponent = lastQuote.datetime ? React.createElement("span", null, "Valor liquidativo a ", React.createElement(DateLabel, {
    date: new Date(lastQuote.datetime),
    format: "L"
  })) : null;
  return React.createElement(LastQuote, {
    value: lastPrice,
    currency: currency === null || currency === void 0 ? void 0 : currency.code,
    label: labelComponent,
    bottomMargin: true
  });
};